import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { useLanguage } from '../i18n/LanguageContext';
export function FAQ() {
  const {
    t
  } = useLanguage();
  const faqs = t.faq.items;
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="pt-10 md:pt-14 pb-20 md:pb-28 bg-riam-dark" data-id="element-35">
      <div className="container mx-auto px-4 md:px-6" data-id="element-36">
        <SectionHeading title={t.faq.title} subtitle={t.faq.subtitle} data-id="element-37" />

        <div className="max-w-3xl mx-auto mt-16" data-id="element-38">
          {faqs.map((faq, index) => <div key={index} className="border-b border-riam-gold/20" data-id="element-39">
              <button className="w-full py-6 flex justify-between items-center text-left focus:outline-none group" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-40">
                <span className="font-script font-semibold text-2xl text-riam-gold group-hover:text-riam-gold-light transition-colors" data-id="element-41">
                  {faq.q}
                </span>
                <ChevronDown className={`icon-glow transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} size={24} stroke="url(#riamGold)" data-id="element-42" />
              </button>
              <AnimatePresence data-id="element-43">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-44">
                    <p className="pb-6 font-sans text-riam-gold-light/80 text-lg leading-relaxed" data-id="element-45">
                      {faq.a}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}